import * as DOMPurifyModule from 'dompurify';

/**
 * dompurify's published .d.ts declares `export =` (CJS shape), but the file webpack actually
 * resolves for an `import` statement is its ESM build, which only has `export { purify as
 * default }`. The two disagree, so `import * as X from 'dompurify'` typechecks but `X.sanitize`
 * is undefined at runtime — the real methods are on `X.default`. tsconfig here has neither
 * esModuleInterop nor allowSyntheticDefaultImports enabled (repo-wide, not worth flipping for one
 * dependency), so this is the narrowest correct workaround rather than a default import.
 */
const DOMPurify: typeof DOMPurifyModule =
  (DOMPurifyModule as unknown as { default: typeof DOMPurifyModule }).default ??
  DOMPurifyModule;

export function sanitizeHtml(dirty: string): string {
  return DOMPurify.sanitize(dirty);
}

export function sanitizeSvg(dirty: string): string {
  return DOMPurify.sanitize(dirty, { USE_PROFILES: { svg: true, svgFilters: true } });
}
